export default __webpack_public_path__ + "static/media/cloading2.96e9535c.gif";